
import React from 'react'
import { Tooltip } from '@mui/material';
import styles from './piiRemoved.module.css';
import PiiRemovedIcon from '../../../../Icons/piiRemoved';

export const PiiRemoved = () => {
    return (
        <Tooltip title="PII Removed" arrow>
            <div className={styles.piiRemovedIcon}>
                <PiiRemovedIcon width={18} height={18}/>
            </div>
        </Tooltip>
    )
}
